import React from 'react';
import { FlexCol, FlexRow, TitleSmall } from '../../../common/components/v2';
import { Resource } from '../../../common/constants/resource';
import { TaskState } from '../../../common/constants/states';
import ElementLocators from '../../../common/ElementLocators';
import { getFormattedTimestamp } from '../../../common/helpers';
import { ITask } from '../../tasks/interfaces/ITask';
import { RuleReview } from '../../tasks/types/ruleReview';
import styles from '../styles.module.scss';
import { NoraTaskIcon } from './components/NoraTaskIcon';
import { TaskDetailsItem } from './components/TaskDetailsItem';
import { TaskNote } from './components/TaskNote';

export const RuleReviewDetail = ({
  task,
  taskStateHandler,
}: {
  task: ITask;
  taskStateHandler: (taskId: number, state: TaskState, reason?: string) => void;
}) => {
  const taskDetail = task.taskData as RuleReview;
  const onTaskStateChange = async (state: TaskState, reason?: string) => {
    if (state) {
      taskStateHandler(task.id, state, reason);
    }
  };

  return (
    <div data-label={ElementLocators.LOCATOR_RULE_REVIEW_SECTION}>
      <FlexRow id={task.id.toString()} className={styles.Title}>
        <FlexCol className={styles.TitleTaskIcon}>
          <NoraTaskIcon task={task} onTaskStateClick={onTaskStateChange} />
        </FlexCol>
        <TitleSmall>{Resource.TASK_TITLE_RULE_REVIEW}</TitleSmall>
        <FlexCol className={styles.CreatedDate}>
          {getFormattedTimestamp(task.retriedAt ?? task.createdAt)}
        </FlexCol>
      </FlexRow>

      {task.state !== TaskState.REQUESTED && (
        <TaskNote taskID={task.id} originalNote={taskDetail?.note} />
      )}
      {taskDetail?.reasonDescription && (
        <>
          <FlexRow className={styles.TaskSubtitle}>{Resource.REASON}</FlexRow>
          <TaskDetailsItem
            leftItem={Resource.DESCRIPTION}
            rightItem={taskDetail.reasonDescription}
          />
        </>
      )}
    </div>
  );
};
